import { VIEWING_WIDTH } from '@/styles';

export const ERROR_BUDGET_DECIMAL_PLACES = 2;
export const ERROR_BUDGET_CALCULATION_DECIMAL_PLACES = 6;
export const SLO_DECIMAL_PLACES = 4;
export const SLI_DECIMAL_PLACES = 3;
export const SLO_CALCULATION_DECIMAL_PLACES = 6;

export const EXPANDED_GRAPH_WIDTH = VIEWING_WIDTH;
export const EXPANDED_GRAPH_HEIGHT = 300;
